export default __webpack_public_path__ + "static/media/personal-photo-light.bc25894a.svg";